module.exports = __webpack_public_path__ + "static/img/rank_302.273ccd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_302.png
// module id = 0CMw
// module chunks = 0